exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-cancel {\n  border: 1px solid var(--v-primary-base) !important;\n  box-shadow: none !important;\n  background-color: #fff !important;\n  color: var(--v-primary-base) !important;\n}\n", ""]);

// exports
